var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstmulo08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_40989)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.03711,
    width: 32,
    height: 32,
    fill: "#F4F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12.114,
    width: 9.84615,
    height: 9.84615,
    fill: "#238FEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23.1909,
    width: 9.84615,
    height: 9.84615,
    fill: "#238FEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0769,
    y: 1.03711,
    width: 9.84615,
    height: 9.84615,
    fill: "#238FEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0769,
    y: 12.114,
    width: 9.84615,
    height: 9.84615,
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0769,
    y: 23.1909,
    width: 9.84615,
    height: 9.84615,
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1539,
    y: 1.03711,
    width: 9.84615,
    height: 9.84615,
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1539,
    y: 12.114,
    width: 9.84615,
    height: 9.84615,
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1539,
    y: 23.1909,
    width: 9.84615,
    height: 9.84615,
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.03711,
    width: 9.84615,
    height: 9.84615,
    fill: "#DBD7D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.537109,
    width: 33,
    height: 33,
    stroke: "#F4F1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_40989"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.03711,
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstmulo08);
export default __webpack_public_path__ + "static/media/Estímulo-08.04c592b6ad68d9c28d666acaa45ec3d1.svg";
export { ForwardRef as ReactComponent };